import { Radio } from '@autopass-web/mochi-component';
import styles from './index.module.scss';

interface RadioGroupProps {
  label?: string;
  list: { id: string; title: string }[];
  value: string;
  name: string;
  onChange: (selectedId: string) => void;
}

export const RadioGroup = ({
  label,
  list,
  value,
  name,
  onChange,
}: RadioGroupProps) => {
  return (
    <>
      {label && <label htmlFor="radio">{label}</label>}
      <div className={styles['radio-group']}>
        {list.map(({ id, title }) => {
          return (
            <Radio
              id={id}
              key={id}
              isChecked={id === value}
              name={name}
              value={title}
              onChange={onChange}
              disabled={false}
            />
          );
        })}
      </div>
    </>
  );
};
